module.exports = __webpack_public_path__ + "img/intergration.29103146.gif";